export { TooltipParcelaEmAtraso } from './tooltip-parcela-em-atraso'
